import MARKER_COLORS from './marker-colors';

export default [
  {
    labelKey: 'hasFuelAndPower',
    color: MARKER_COLORS.FULL_AMENITIES,
  },
  {
    labelKey: 'hasNoPower',
    color: MARKER_COLORS.NO_POWER,
  },
  {
    labelKey: 'limitedFuelOptions',
    color: MARKER_COLORS.LIMITED_AMENITIES,
  },
  {
    labelKey: 'hasNoFuelAndPower',
    color: MARKER_COLORS.NO_AMENITIES,
  },
];
